import { Fragment } from 'react';
import useClubTouchpoint from './UseClubTouchpoints';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

import ClubTouchpointsGrid from './ClubTouchpointsGrid';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

const ClubTouchpoints = () => {
  const {
    baseUsasClubState,
    clubTouchpointState,
    onAdd,
    onEdit,
    onDelete
  } = useClubTouchpoint();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Touchpoints</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin">
          <ActionIntraPageButton onClick={onAdd}>Add Touchpoint</ActionIntraPageButton>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubTouchpointsGrid data={clubTouchpointState.arrayData} onEditClicked={onEdit} onDeleteClicked={onDelete} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={baseUsasClubState.isObjLoading || clubTouchpointState.isArrayLoading || clubTouchpointState.isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={clubTouchpointState.isSaving} />
    </Fragment>);
}

export default ClubTouchpoints;